import { inject, InjectionToken, Provider } from '@angular/core';
import {
  provideSoftAppsModule,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { getModuleGroupByName } from '@softline/application';
import { default as de } from '../i18n/de.json';
import { default as en } from '../i18n/en.json';
import { SOFTLINE_PERMISSION_MDC_INVENTORY } from './mdc-inventory.const';
import { mdcInventoryRouteFactory } from './mdc-inventory.routes';
import { MdcInventoryConfig } from './mdc-inventory.tokens';

export function provideMdcInventory(config?: MdcInventoryConfig): Provider[] {
  return [
    provideSoftAppsModule(
      {
        name: 'MdcInventory',
        title: '#MDC_INVENTORY.MODULE_TITLE',
        icon: 'fa-regular fa-box-circle-check',
        route: '/mdc-inventory/setup/storage-location',
        permission: SOFTLINE_PERMISSION_MDC_INVENTORY,
        group: getModuleGroupByName('MDC'),
      },
      withSoftAppsModuleRoutes({ app: mdcInventoryRouteFactory(config ?? {}) }),
      withSoftAppsModuleTranslation({ de, en }),
      withSoftAppsModuleInfo({
        library: '@softapps/mdc/inventory',
        remoteConfig: 'mdc-inventory',
        description: 'Inventur mit dem MDC-Gerät.',
      })
    ),
  ];
}
